module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTVjMzY3ZjgwMDM2OTIyYjYyMThlOGI1NGY0Y2ZmYjYucG5nIjs="